import { render, staticRenderFns } from "./SportsbookBets.vue?vue&type=template&id=8f46b33c&scoped=true&"
import script from "./SportsbookBets.vue?vue&type=script&lang=js&"
export * from "./SportsbookBets.vue?vue&type=script&lang=js&"
import style0 from "./SportsbookBets.vue?vue&type=style&index=0&id=8f46b33c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f46b33c",
  null
  
)

export default component.exports